<app-progress-spinner *ngIf="!showGrid"></app-progress-spinner>

<div class="label-heading">
    <label class="label-commentheadercolor">Discussion</label>
</div>
<form (ngSubmit)="addComment()" class="comment-form" style="min-height: 100px;">
    <quill-editor placeholder="Add a comment" required class="formControl" (keyup)="onKeyUp($event)"
        [(ngModel)]="newComment" (ngModelChange)="onCommentChange()" role="textbox" name="comment" required [readOnly]="!isEditable"></quill-editor>
    <mat-option class="font-control" *ngFor="let user of submitterSearchData" [value]="user.Email"
        (click)="onEmailclick(user.Email)">
        {{ user.Email }}
    </mat-option>
    <button class="button commentbutton" style="margin-right: 5px; margin-top: 5px;" type="submit"
        (click)="onCancel()">Clear Comment</button>
    <button class="button commentbutton" style="margin-right: 5px; margin-top: 5px;" type="submit">Save
        Comment</button>
</form>
<div class="comments-list" style="padding-top: 3%;">
    <div *ngFor="let comment of selectedCommentsData">
        <mat-card class="comment-card">
            <mat-card-header>
                <mat-card-title>{{comment.UserName}}</mat-card-title>
                <mat-card-content style="font-size: 12px !important;">{{comment.CreatedOn}}</mat-card-content>
            </mat-card-header>
            <mat-card-content>
                <div class="comment-text" [innerHTML]="comment.CommentText"></div>
            </mat-card-content>
        </mat-card>
    </div>
</div>